/** Featured templates shown during onboarding first-trip selection. */
export const ONBOARDING_FEATURED_TEMPLATES = [
  {
    id: "qxgjzi6GHZ8OmHK967sT",
    slug: "nyc-world-cup-weekend",
    topicTag: "world-cup-2026",
    eyebrow: "World Cup 2026",
  },
  {
    id: "epsa0Jlk1xhO7tUZ835I",
    slug: "calgary-stampede-banff-5-days",
    topicTag: "calgary-stampede",
    eyebrow: "Calgary Stampede",
  },
  {
    id: "gJev0R9uaJ8Z5F0LHChc",
    slug: "america-250-3-days-in-dc",
    topicTag: "america-250",
    eyebrow: "America 250",
  },
] as const;

export type OnboardingFeaturedTemplateRef = (typeof ONBOARDING_FEATURED_TEMPLATES)[number];
